import React from "react";
import Icon from "../Icon/Icon";
import Api from "../../api";

import coinIcon from "icons/coin.svg";
import personWhiteIcon from "icons/person-white.svg";
import logoutIcon from "icons/logout.svg";
import { numberWithSpaces } from "../../utils";

export default class HeaderUser extends React.PureComponent {
  logout = () => {
    Api.logout().then(() => {
      window.location.reload();
    });
  };

  render() {
    const { profile, balance = "" } = this.props;
    return (
      <div className="header-user">
        <div className="header-user__name text-icon">
          <Icon className="text-icon__icon" glyph={ personWhiteIcon }/>
          { profile.username }
        </div>

        <div className="header-user__balance text-icon">
          <Icon className="text-icon__icon" glyph={ coinIcon }/>
          { balance !== null ? <span>{ numberWithSpaces(Math.floor(balance)) } REX</span> : <span>...</span>}
        </div>

        <span onClick={ this.logout } className="header-user__logout">
          <Icon glyph={ logoutIcon }/>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/HeaderUser/HeaderUser.jsx